import React, { useContext } from 'react'

import AppContext from './AppContext'
import CurrencyFormat from 'react-currency-format'

const TotalTax = ({ total, currency }) => {
  const myContext = useContext(AppContext)
  return (
    <div className="flex flex-row justify-between font-bold">
      <div className="w-1/3"></div>
      <div className="w-1/6"></div>
      <div className="w-1/6 text-right">Total</div>
      <div className="w-1/6 text-right">
        <CurrencyFormat
          value={total}
          displayType={'text'}
          thousandSeparator={true}
          decimalScale={2}
          fixedDecimalScale={true}
          prefix={currency || myContext.currency}
        />
      </div>
    </div>
  )
}

export default TotalTax
